import React, { useState, useEffect } from 'react'
import { VITE_API_BASE as API_BASE } from '../config/apiConfig'
import { message } from 'antd'

const WorkReview = () => {
  const [works, setWorks] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('pending')
  const [selectedWork, setSelectedWork] = useState(null)

  useEffect(() => {
    fetchWorks()
  }, [filter])

  const fetchWorks = async () => {
    setLoading(true)
    try {
      const res = await fetch(`${API_BASE}/ugc-creator/works?status=${filter}`)
      const data = await res.json()
      if (data.success) {
        setWorks(data.data || [])
      }
    } catch (err) {
      message.error('获取作品失败')
    }
    setLoading(false)
  }

  const handleApprove = async (work) => {
    try {
      const res = await fetch(`${API_BASE}/ugc-creator/works/${work.id}/approve`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
      })
      const data = await res.json()
      if (data.success) {
        message.success('审核通过')
        fetchWorks()
      } else {
        message.error(data.error || '操作失败')
      }
    } catch (err) {
      message.error('操作失败')
    }
  }

  const handleReject = async (work, reason) => {
    try {
      const res = await fetch(`${API_BASE}/ugc-creator/works/${work.id}/reject`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reason })
      })
      const data = await res.json()
      if (data.success) {
        message.success('已拒绝')
        fetchWorks()
      } else {
        message.error(data.error || '操作失败')
      }
    } catch (err) {
      message.error('操作失败')
    }
  }

  const getStatusBadge = (status) => {
    const badges = {
      pending: { color: '#faad14', text: '待审核' },
      approved: { color: '#52c41a', text: '已通过' },
      rejected: { color: '#f5222d', text: '已拒绝' }
    }
    const badge = badges[status] || badges.pending
    return <span style={{ color: badge.color }}>{badge.text}</span>
  }

  return (
    <div style={{ padding: 24 }}>
      <h2>🎨 作品审核管理</h2>
      
      {/* 筛选标签 */}
      <div style={{ marginBottom: 24 }}>
        {['pending', 'approved', 'rejected'].map(status => (
          <button
            key={status}
            onClick={() => setFilter(status)}
            style={{
              marginRight: 12,
              padding: '8px 16px',
              border: 'none',
              borderRadius: 4,
              background: filter === status ? '#667eea' : '#f0f0f0',
              color: filter === status ? '#fff' : '#666',
              cursor: 'pointer'
            }}
          >
            {status === 'pending' ? '待审核' : status === 'approved' ? '已通过' : '已拒绝'}
          </button>
        ))}
      </div>

      {/* 作品列表 */}
      {loading ? (
        <div>加载中...</div>
      ) : works.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#999', padding: 48 }}>暂无作品</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
          {works.map(work => (
            <div
              key={work.id}
              style={{
                background: '#fff',
                borderRadius: 8,
                padding: 16,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
            >
              <div style={{ width: '100%', height: 200, background: '#f0f0f0', borderRadius: 8, marginBottom: 12 }}>
                {work.cover && <img src={work.cover} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }} />}
              </div>
              <h4 style={{ margin: '0 0 8px' }}>{work.title}</h4>
              <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>
                作者：{work.child_name} | {getStatusBadge(work.status)}
              </div>
              <p style={{ fontSize: 12, color: '#999', marginBottom: 12 }}>
                创建时间：{work.created_at?.substring(0, 10)}
              </p>
              
              {filter === 'pending' && (
                <div style={{ display: 'flex', gap: 8 }}>
                  <button
                    onClick={() => handleApprove(work)}
                    style={{
                      flex: 1,
                      padding: '8px 0',
                      background: '#52c41a',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 4,
                      cursor: 'pointer'
                    }}
                  >
                    通过
                  </button>
                  <button
                    onClick={() => {
                      const reason = prompt('请输入拒绝原因：')
                      if (reason) handleReject(work, reason)
                    }}
                    style={{
                      flex: 1,
                      padding: '8px 0',
                      background: '#f5222d',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 4,
                      cursor: 'pointer'
                    }}
                  >
                    拒绝
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default WorkReview
